import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Breadcrumbs from "../../../common/BreadcrumbsModule";
import {breadcrumbsSelector} from "../../ducks/breadcrumbs";

function BreadcrumbsContainer({items}) {
  return <Breadcrumbs items={items} />;
}

BreadcrumbsContainer.propTypes = {
  items: PropTypes.array
};

export default connect((state) => ({
  items: breadcrumbsSelector(state)
}))(BreadcrumbsContainer);
